// import header_toggleIsCompact from "../../../toggle-button/function/toggle-is-compact"

import {ProjectSystemType} from "../../../../../../../../core/model2/project/types"
import {BUS_TOGGLE_SUBMENU} from "../../../../../../../../core/gd/bus/bus-event-type"

// const debug = "addView_checkConvertRequirementAndConfirm"
const debug = false

export default function addView_checkConvertRequirementAndConfirm(projectId : ID): Promise<'continue' | 'convert' | 'stop'> {
    return new Promise((resolve, reject) => {
        const project = gd.session.projects.get(projectId)

        if (!project) {
            console.warn('addView_checkConvertRequirementAndConfirm: no project', projectId)
            return
        }

        // const showWarning = project.isPage || project.isEmbed
        const showWarning = project.isSingleView

        debug && console.log(debug, 'process', showWarning)

        if (!showWarning) {
            resolve('continue')
            return
        }

        toggleAllPopovers(true)

        let title = ''
        let message = ''

        switch (project.systemType) {
            case ProjectSystemType.SINGLE_VIEW_TODOS:
            case ProjectSystemType.SINGLE_VIEW_GOALS:
            case ProjectSystemType.SINGLE_VIEW_FILES:
            case ProjectSystemType.SINGLE_VIEW_MEETINGS:
            case ProjectSystemType.SINGLE_VIEW_EXPENSES:
            case ProjectSystemType.SINGLE_VIEW_CHATS:
            case ProjectSystemType.SINGLE_VIEW_TASK_LIST:
            case ProjectSystemType.SINGLE_VIEW_TASK_BOARD:
                title   = 'Convert'
                message = 'You are trying to add a view to a single view resource. ' +
                    'It should be converted to Folder before new view is added. ' +
                    'Are you sure you want to convert it into Folder? ' +
                    'This action cannot be reverted.'
                break

            case ProjectSystemType.PAGE:
                title   = 'Convert page'
                message = 'You are trying to add a view to Page. ' +
                    'It should be converted to Folder before new view is added. ' +
                    'Are you sure you want to convert Page into Folder? ' +
                    'This action cannot be reverted.'
                break
            case ProjectSystemType.WHITEBOARD:
                title   = 'Convert whiteboard'
                message = 'You are trying to add a view to Whiteboard. ' +
                    'It should be converted to Folder before new view is added. ' +
                    'Are you sure you want to convert Whiteboard into Folder? ' +
                    'This action cannot be reverted.'
                break

            case ProjectSystemType.EMBED:
                title   = 'Convert embed'
                message = 'You are trying to add a view to Embed structure element. ' +
                    'It should be converted to Folder before new view is added. ' +
                    'Are you sure you want to convert Embed structure element into Folder? ' +
                    'This action cannot be reverted.'
                break
        }

        gd.modals.confirm.genericText(title,message, async () => {
            gd.modal.hide()
            toggleAllPopovers(false)
            resolve('convert')

            await gd.api.Project.convertToFolder(projectId, {}).promise()
            gd.bus.triggerEvent(BUS_TOGGLE_SUBMENU)
            // header_toggleIsCompact(projectId)
        }, {
            yesBtnLabel : 'Yes, proceed',
            onNoCallback: () => {
                toggleAllPopovers(false)
                resolve('stop')
            }
        })
    })
}

function toggleAllPopovers(value: boolean) {
    _.map(document.querySelectorAll('.popover'), node=>{
        debug && console.log(debug, 'toggleAllPopovers', node.childNodes[0], node)

        gd.utils.Dom.toggleClass(node.childNodes[0], "is-hidden", value)
    })
}
